import { MapContainer, LayersControl, TileLayer, Marker, Circle } from 'react-leaflet'
import { LeafletMouseEvent, Map as MapType } from 'leaflet'
import React, { useEffect, useRef, useState } from 'react'
import { mapLocation } from 'pages/Map/icons'
import 'leaflet/dist/leaflet.css'
import 'pages/Map/index.scss'

interface MapProps {
  coords?: base.Coords
  getLocation: base.BasicFunc
  updatePosition: (coords: base.Coords) => void
}

const Map: React.FC<MapProps> = ({ coords, getLocation, updatePosition }) => {
  const position: [number, number] | undefined = coords ? [coords.latitude, coords.longitude] : undefined
  const [isReady, setReady] = useState(false)
  const mapRef = useRef<MapType>(null)

  useEffect(() => {
    const map = mapRef.current
    if (isReady) {
      const getClickPosition = ({ latlng }: LeafletMouseEvent) => {
        updatePosition({
          latitude: latlng.lat,
          longitude: latlng.lng,
          accuracy: 0,
        })
      }
      map?.on('click', getClickPosition)
      return () => {
        map?.off('click', getClickPosition)
      }
    }
  }, [isReady, updatePosition])

  useEffect(() => {
    const map = mapRef.current
    if (isReady && coords) {
      map?.flyTo([coords.latitude, coords.longitude])
    }
  }, [isReady, coords])

  return (
    <div className='map__leaflet__container'>
      <MapContainer
        ref={mapRef}
        zoom={16}
        minZoom={3}
        maxZoom={18}
        scrollWheelZoom={true}
        className='map__leaflet'
        center={position || [52, 19]}
        whenReady={() => setReady(true)}>

        <LayersControl>
          <LayersControl.BaseLayer name="Ulice">
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO Google</a>'
              url={`https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png`}
            />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer checked name="Satelita">
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO Google</a>'
              url={`https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}`}
              subdomains={["mt0", "mt1", "mt2", "mt3"]}
            />
          </LayersControl.BaseLayer>
        </LayersControl>

        {position && <Marker
          icon={mapLocation}
          position={position}
        />}

        {coords && coords.accuracy > 10 && <Circle
          radius={coords.accuracy}
          center={position!}
        />}
      </MapContainer>

      <div className='location__button__container'>
        <button
          className='location__button'
          onClick={e => {
            e.stopPropagation()
            if (navigator.geolocation) {
              getLocation()
            }
          }}>
          <i className='icon icon--map-location s18' />
        </button>
      </div>
    </div>
  )
}

export default Map